import { useMemo } from 'react'
import { ShareLink as View } from 'ui-components'
import { useAuth } from 'user-auth'
import { getWorkspaceInviteLink, useClipboard } from 'utils'
import { useMap } from '~map-preview/states/map'

function LinkShare() {
  const { user } = useAuth()
  const map = useMap()
  const [, copyToClipboard] = useClipboard()
  const workspace = map?.workspace

  const inviteLink = useMemo(() => {
    if (!workspace) return ''
    return getWorkspaceInviteLink(
      workspace.id,
      workspace.name,
      workspace.inviteId
    )
  }, [workspace])

  const isWorkspaceMember = useMemo(() => {
    if (!map || !Object.keys(map).length) return false
    if (!user) return false

    return map.workspace.memberCollection.items.some(
      (member) => member.user.id === user.id
    )
  }, [map, user])

  if (!isWorkspaceMember) return null
  return (
    <View
      inviteLink={inviteLink}
      onCopyInviteLinkClick={() => copyToClipboard(inviteLink)}
    />
  )
}

export { LinkShare }
